<div class="search-wrapper">
  <h2>FIND A FAMILY PLANNING CLINIC</h2>
  <div class="search-bar-wrapper">
    <input
      #searchAddressInput
      aria-label="Enter a street address, city, or zip code"
      type="text"
      class="search-bar"
      placeholder="Enter a street address, city, or zip code"
    />
    <button
      type="submit"
      class="search-button"
      (click)="routeSearchResults(searchAddressInput.value)"
      aria-label="search"
      [disabled]="!searchAddressInput.value"
    >
      <mat-icon class="search-icon">search</mat-icon>
    </button>
  </div>
</div>
